import React from "react";
import { Box, Typography, Grid, Card, Link } from "@mui/material";
import ImgPath from "../../Constants/Imgs";

const services = [
  {
    title: "Apply for Legal",
    img: ImgPath.ApplyLegelIcon,
  },
  {
    title: "Settle Your Legal Disputes",
    img: ImgPath.LegelDisputesIcon,
  },
  {
    title: "Register Your Business",
    img: ImgPath.RegisterBusinessIcon,
  },
  {
    title: "Protect Your Business",
    img: ImgPath.ProtectBusinessIcon,
  },
  {
    title: "Talk to Lawyer",
    img: ImgPath.TalkToLawyerIcon,
    extra: ["To CA", "To CS"],
  },
  {
    title: "Online Documentation",
    img: ImgPath.OnlineDocumentation,
    extra: ["Send Notice", "Reply Notice"],
  },
  {
    title: "File Tax",
    img: ImgPath.FileTaxIcon,
  },
  {
    title: "File a Case",
    img: ImgPath.FileCaseIcon,
  },
  {
    title: "Apply for Legal",
    img: ImgPath.ApplyLegelIcon,
  },
  {
    title: "Settle Your Legal Disputes",
    img: ImgPath.LegelDisputesIcon,
  },
  {
    title: "Register Your Business",
    img: ImgPath.RegisterBusinessIcon,
  },
  {
    title: "Protect Your Business",
    img: ImgPath.ProtectBusinessIcon,
  },
  {
    title: "Talk to Lawyer",
    img: ImgPath.TalkToLawyerIcon,
    extra: ["To CA", "To CS"],
  },
  {
    title: "Online Documentation",
    img: ImgPath.OnlineDocumentation,
    extra: ["Send Notice", "Reply Notice"],
  },
  {
    title: "File Tax",
    img: ImgPath.FileTaxIcon,
  },
  {
    title: "File a Case",
    img: ImgPath.FileCaseIcon,
  },
];

const ServicesSection = () => {
  return (
    <Box sx={{ py: 6, backgroundColor: "#f6ebe3" }}>
      <Grid
        container
        spacing={4}
        sx={{
          maxWidth: 1100, // adjust as needed
          margin: "0 auto",
          justifyContent: "center",
        }}
      >
        {services.map((service, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            lg={3}
            key={index}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Card
              sx={{
                width: 250,
                height: 250,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
                borderRadius: 2,
                padding: 2,
                transition: "0.3s",
                textAlign: "center",
                "&:hover": {
                  transform: "translateY(-10px) scale(1.02)",
                  boxShadow: 3,
                  backgroundColor: "#fff",
                  borderColor: "#fff",
                },
              }}
            >
              <Typography variant="h6" component="h5" sx={{ fontWeight: 600 }}>
                {service.title}
              </Typography>
              <Box
                component="img"
                src={service.img}
                alt={service.title}
                sx={{ width: 70, height: "auto" }}
              />
              {service.extra?.map((text, i) => (
                <Typography key={i} variant="body2" color="text.secondary">
                  {text}
                </Typography>
              ))}
              <Link
                href="#"
                underline="none"
                sx={{
                  color: "#8d2b3b",
                  fontWeight: 500,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                Know more <i className="fa fa-angle-right" />
              </Link>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ServicesSection;
